export default class {
  init() {
    const $elements = $("section.colour-swatches");

    if ($elements.length) {
      (async () => {
        const Vue = (await import("vue")).default;

        [...$elements].forEach((el) => {
          new Vue({
            data() {
              return {
                loading: false,
                submitting: false,
                form: {},
                items: [],
              };
            },
            mounted() {
              window.App.aos.refreshHard();
              this.fetch();
            },
            methods: {
              submit() {
                this.submitting = true;
                this.fetch();
              },

              fetch() {
                this.loading = true;

                $.ajax({
                  method: "POST",
                  dataType: "json",
                  url: `${window.App.ajaxUrl}`,
                  data: { action: "get-colour-swatches", ...this.form },
                })
                  .then(
                    (res) => {
                      window.App.aos.refreshHard();
                      this.items = res.results;
                    },
                    (err) => {
                      console.error(err);
                    },
                  )
                  .done(() => {
                    this.loading = false;
                    this.submitting = false;
                  });
              },
            },
          }).$mount(el);
        });
      })();
    }
  }
}
